import { useEffect, useState } from 'react'
import axios from 'axios'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { Breadcrumb, Image } from 'react-bootstrap'
import draftToHtml from 'draftjs-to-html';
import { EditorState, convertToRaw } from 'draft-js';

import { FaMoneyBill, FaCheck, FaArrowLeft, FaArrowRight, FaPlus } from 'react-icons/fa'

import './create.css'
import EventInfoForm from '../../../components/events/info-form'
import EventsTicketContainer from '../../../components/events/tickets-container'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { Link } from 'react-router-dom'

export default function Create() {
  const breadcrumbs = useBreadcrumbs();
  const [step, setStep] = useState(0)
  const [productType, setProductType] = useState('')
  const [eventId, setEventId] = useState(null)
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [venueName, setVenueName] = useState(null)
  const [venueAddress, setVenueAddress] = useState(null)
  const [flyerImage, setFlyerImage] = useState(null)
  const [flyerImagePreview, setFLyerImagePreview] = useState(null)
  const [eventTickets, setEventsTickets] = useState([])
  const [eventDetailFormIsValid, setEventDetailFormIsValid] = useState(false)
  const [savingEvent, setSavingEvent] = useState(false)
  const [description, setDescription] = useState(EditorState.createEmpty())

  useEffect(() => {
    if (flyerImage) {
      var reader = new FileReader()
      var url = reader.readAsDataURL(flyerImage[0])
      reader.onloadend = function (e) {
        setFLyerImagePreview(reader.result)
      }
    }
  }, [flyerImage])

  useEffect(() => {
    setEventDetailFormIsValid(false);
    if (name && startDate && endDate && venueAddress && flyerImage) {
      setEventDetailFormIsValid(true);
    }
  }, [name, startDate, endDate, venueAddress, flyerImage]);

  useEffect(()=>{
    if (productType !== '') {
      setStep(step + 1);
    }
  }, [productType]);


  const createEvent = () => {
    const newProductForm = new FormData()
    newProductForm.set('status', 'published')
    sendRequestToServer(newProductForm)
  }

  const saveEventToDraft = () => {
    const newProductForm = new FormData()
    newProductForm.set('status', 'draft')
    sendRequestToServer(newProductForm)
  }

  const sendRequestToServer = (form) => {
    form.set('type', productType);
    form.set('name', name);
    if (description) {
      form.set('description', draftToHtml(convertToRaw(description.getCurrentContent())));
    }
    form.set('startDate', startDate);
    form.set('endDate', endDate);
    form.set('venueName', venueName);
    form.set('venueAddress', venueAddress);
    if (flyerImage) {
      form.set('flyerImage', flyerImage[0], flyerImage.name);
    }
    // console.log(form)
    const _user = JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_LOCALSTOAGE_KEY));
    const _userToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_LOCALSTOAGE_KEY);
    setSavingEvent(true);
    const post_status = form.get('status');
    axios.post(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events', form, {
      headers: {
        'Authorization': 'Basic ' + btoa(_user.user_login  +  ":"  +  _userToken),
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => {
      console.log(res.data);
      const event = res.data.event
      if (productType == 'variable') {
        window.location = '/events/'+event.id+'/tickets';
      } else {
        window.location = '/events/';
      }
    }).catch((err) => {
      console.log(err.message);
      alert('Failed to ' + post_status + ' event.');
    }).finally(() => {
      setSavingEvent(false);
    });
  }

  console.log(eventDetailFormIsValid)
  return (
    <Container>
      <section className='create-event'>
      <Breadcrumb>
        {breadcrumbs.map(({ breadcrumb, key, location, match }, index) => {
          return <Breadcrumb.Item key={index} href={key}>{breadcrumb}</Breadcrumb.Item>
        })}
        </Breadcrumb>
        <div className='p-relative'>
          {step === 0 && (
            <div className="py-5">
              <p className="fs-2x text-center">Let's launch your next event</p>
              <Row className="justify-content-center" style={{ rowGap: '1rem' }}>
                <Col sm="4">
                  <Card body className="text-center"
                    style={{ cursor: 'pointer' }}
                    onClick={()=>{
                      setProductType('variable')
                    }}
                  >
                    <FaMoneyBill size={48}/>
                    <span className="d-block">Sell Tickets</span>
                  </Card>
                </Col>
                <Col sm="4">
                  <Card body className="text-center"
                    style={{ cursor: 'pointer' }}
                    onClick={()=>{
                      setProductType('simple')
                    }}
                  >
                    <FaCheck size={48}/>
                    <span className="d-block">RSVP Only</span>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
          {step === 1 && (
            <>
              <Row className="mb-3">
                <Col md="6">
                  <h3>Event Details</h3>
                  <EventInfoForm
                    name={name}
                    startDate={startDate}
                    endDate={endDate}
                    venueName={venueName}
                    venueAddress={venueAddress}
                    flyerImage={flyerImage}
                    setName={setName}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    setVenueName={setVenueName}
                    setVenueAddress={setVenueAddress}
                    setFlyerImage={setFlyerImage}
                    description={description}
                    setDescription={setDescription}
                  />
                </Col>
                <Col md="6">
                  {flyerImagePreview ? (
                    <div className="create-event-banner-image" style={{ backgroundImage: 'url(' + flyerImagePreview + ')' }}>
                      <div className="create-event-banner-image_overlay"></div>
                      <Image src={flyerImagePreview} className="create-event-flyer-image" alt=""/>
                    </div>
                  ) : (
                    <Card>
                      <Card.Body className='text-center'>Select the Flyer Image to see the preview of it.</Card.Body>
                    </Card>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    variant='light'
                    onClick={()=>{
                      setStep(0);
                  }}>
                    <FaArrowLeft /> Back
                  </Button>
                </Col>
                <Col className="text-right">
                  {productType === 'simple' ? (
                    <>
                      <Button
                        variant="secondary"
                        className='m-3'
                        disabled={(savingEvent || !eventDetailFormIsValid)}
                        onClick={()=>{saveEventToDraft()}}>
                        Save To Draft
                      </Button>
                      <Button
                        variant="primary"
                        className='m-3'
                        disabled={(savingEvent || !eventDetailFormIsValid)}
                        onClick={()=>{createEvent()}}>
                        Publish Event
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="secondary"
                        className='m-3'
                        disabled={(savingEvent || !eventDetailFormIsValid)}
                        onClick={()=>{saveEventToDraft()}}>
                        Save To Draft
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </>
          )}
        </div>
      </section>
    </Container>
  )
}
